export default {
  // 评估、历史成交
  getConstrutionViewInfoById: {
    url: '/v1/query/assess/getConstrutionViewInfoById',
  },
  getBuild: { url: '/v1/query/assess/getBuild' },
  getHouse: { url: '/v1/query/assess/getHouse' },
  searchAssessCollect: { url: '/v1/query/assess/searchAssessCollect' },
  tradeVoPage: { url: '/v1/query/deal/tradeVoPage' },
  board: { url: '/v1/query/deal/board' },
  price: { url: '/v1/query/deal/price' },
  rootType: { url: '/v1/query/deal/rootType' },
  detail: { url: '/v1/query/assess/detail' },
  address: { url: '/v1/query/tools/address' },
  searchAreaList: { url: '/v1/query/deal/searchAreaList' },
  history: { url: '/v1/query/deal/history' },
  getHistoryAnalyse: { url: '/v1/query/deal/analyse' },
  housingEstate: { url: '/v1/query/deal/housingEstate' },

  // 查婚姻 - 历史记录
  queryMarriage: { url: '/v1/query/tools/marriage' },
  queryMarriageDetail: { url: '/v1/query/tools/queryMarriageDetail' },

  // 要素校验
  verifyIdCardAndName: { url: '/v1/query/tools/verifyIdCardAndName' },
  verifyThree: { url: '/v1/query/tools/verifyThree' },
  verifyThreeDetail: { url: '/v1/query/tools/verifyThreeDetail' },
  verifyFour: { url: '/v1/query/tools/verifyFour' },
  verifyFourDetail: { url: '/v1/query/tools/verifyFourDetail' },

  // 查房产
  realEstate: { url: '/v1/query/tools/realEstate' },
  searchRealEstateDetail: { url: '/v1/query/tools/searchRealEstateDetail' },
  // 查社保
  socialSecurity: { url: '/v1/query/tools/socialSecurity' },
  querySocialSecurityDetail: {
    url: '/v1/query/tools/querySocialSecurityDetail',
  },
  searchRecord: { url: '/v1/query/center/record' },
  // 诉讼
  lawsuitPerson: { url: '/v1/query/lawsuit/search' },
  lawsuitDetail: { url: '/v1/query/lawsuit/detail' },
  searchLawsuitHistory: { url: '/v1/query/lawsuit/searchLawsuitHistory' },
  searchEnterpriseLawsuit: { url: '/v1/query/lawsuit/searchEnterpriseLawsuit' },
  enterpriseBigEnterprise: { url: '/v1/query/lawsuit/searchBigEnterpriseByName' },
  // 查询名下车辆
  queryCarCount: { url: '/v1/query/car/queryCarCount' },
  // 查询车辆过户次数信息
  queryCarTransfer: { url: '/v1/query/car/queryCarTransfer' },
  // 查询字典信息（1.车辆颜色，2.车辆型号，3.事故情况，4.外观选项，5.电气设备，6.发动机，7.内是选项,8.二手车车辆颜色）
  queryDictionary: { url: '/v1/query/car/queryDictionary' },
  // 人/企车主核验
  queryCarContact: { url: '/v1/query/car/queryCarContact' },
  // 查五项
  queryCarVinFive: { url: '/v1/query/car/queryCarVinFive' },
  // 行驶证查询
  queryDrivingLicense: { url: '/v1/query/car/queryDrivingLicense' },
  // 车辆保险
  queryCarAccident: { url: '/v1/query/car/queryCarAccident' },
  // 出险记录详情
  queryCarAccidentInfo: { url: '/v1/query/car/queryCarAccidentInfo' },
  // 车辆估值
  queryCarAssess: { url: '/v1/query/car/queryCarAssess' },
  // 估值品牌列表
  queryCarBrand: { url: '/v1/query/car/queryCarBrand' },
  // 估值车系
  queryCarSeries: { url: '/v1/query/car/queryCarSeries' },
  // 估值车型列表
  queryCarType: { url: '/v1/query/car/queryCarType' },
  // 出险记录详情-历史记录
  queryCarAccidentInfoDetail: {
    url: '/v1/query/car/queryCarAccidentInfoDetail',
  },
  // 名下车辆查询-历史记录
  queryCarCountDetail: { url: '/v1/query/car/queryCarCountDetail' },
  // 查询车辆过户次数信息-历史记录
  queryCarTransferDetail: { url: '/v1/query/car/queryCarTransferDetail' },
  // 人/企车主核验-历史记录
  queryCarContactDetail: { url: '/v1/query/car/queryCarContactDetail' },
  // 车辆精准估值-历史记录
  queryCarAssessDetail: { url: '/v1/query/car/queryCarAssessDetail' },
  // 查五项-历史记录
  queryCarVinFiveDetail: { url: '/v1/query/car/queryCarVinFiveDetail' },
  // 行驶证查询-历史记录
  queryDrivingLicenseDetail: { url: '/v1/query/car/queryDrivingLicenseDetail' },
  // 车辆保险详情
  queryCarAccidentDetail: { url: '/v1/query/car/queryCarAccidentDetail' },
  // 查询价格配置
  queryPriceConfigPage: { url: '/v1/sys/wallet/queryPriceConfigPage' },
  initiateSearch: { url: '/v1/query/customized/initiateSearch' },
  // 摘要页
  summarize: { url: '/v1/query/customized/summarize' },
  searchField: { url: '/v1/query/customized/searchField' },
  // 创建消费
  createPay: { url: '/v1/order/createPay' },
  // 发起授权
  enterpriseTaxV2Authorize: { url: '/v1/query/authorization/generateUrl' },
  // 企业授权-详情
  enterpriseTaxV2Detail: { url: '/v1/enterprise/tax/v2/detail' },
  // 查询站点状态
  enterpriseQueryBureaVo: { url: '/v1/enterprise/tax/v2/queryBureaVo' },
  // 企业站点状态(-2:维护中，0.正常，1.暂不支持此区域)
  enterpriseQueryEnterpriseStatus: { url: '/v1/enterprise/tax/v2/queryEnterpriseStatus' },
};
